module.exports = __webpack_public_path__ + "static/media/jm.4c0089eb.svg";